var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 61,
    viewBox: "0 0 45 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 0,
    width: 12,
    height: 3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1275 0H23.2676V2.56178H34.1275V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2923 2.07423H25.1061C24.6958 2.07423 24.3245 1.82979 24.1633 1.44846L23.7578 0.490234H33.6407L33.2352 1.44846C33.074 1.8249 32.7027 2.07423 32.2923 2.07423Z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2916 2.56275H25.1054C24.4996 2.56275 23.9524 2.20097 23.7131 1.64364L23.3076 0.685415C23.2001 0.436081 23.3174 0.147638 23.5616 0.0449714C23.6251 0.0205269 23.6886 0.00585938 23.757 0.00585938H33.6399C33.9086 0.00585938 34.1284 0.225859 34.1284 0.494748C34.1284 0.563193 34.1137 0.626748 34.0893 0.685415L33.6838 1.64364C33.4494 2.20097 32.9022 2.56764 32.2916 2.56764V2.56275ZM24.4947 0.978749L24.6119 1.25742C24.695 1.45297 24.8855 1.58008 25.1005 1.58008H32.2867C32.5016 1.58008 32.6921 1.45297 32.7752 1.25742L32.8973 0.978749H24.4898H24.4947Z",
    fill: "#040000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 0,
    width: 25,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5137 0H16.8789V43.7262H40.5137V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4388 0H23.7573C23.9527 0 24.1286 0.117334 24.2068 0.298223L24.6123 1.25644C24.6953 1.452 24.8858 1.57911 25.1008 1.57911H32.2919C32.5068 1.57911 32.6973 1.452 32.7853 1.25644L33.1907 0.298223C33.2689 0.117334 33.4448 0 33.6402 0H37.9587C39.3755 0 40.5186 1.14889 40.5235 2.56178V41.1644C40.5235 42.5773 39.3755 43.7262 37.9636 43.7262H19.4485C18.0367 43.7262 16.8887 42.5773 16.8887 41.1644V38.0258C17.045 36.1289 17.045 34.2222 16.8887 32.3253V18.8662C17.1818 16.2996 17.1818 14.344 16.8984 12.9996L16.8887 2.56178C16.8887 1.14889 18.0318 0.00488889 19.4437 0H19.4388ZM23.4349 0.977778H19.4388C18.5643 0.977778 17.856 1.68667 17.856 2.56178V12.8969C18.1491 14.2462 18.154 16.3044 17.856 18.92V32.2813C18.0172 34.2076 18.0172 36.1387 17.856 38.0649V41.1644C17.856 42.0396 18.5643 42.7484 19.4388 42.7484H37.9539C38.8283 42.7484 39.5367 42.0396 39.5367 41.1644V2.56667C39.5367 1.69156 38.8283 0.982666 37.9539 0.982666H33.9626L33.6842 1.64267C33.4497 2.2 32.8976 2.56178 32.2919 2.56178H25.1008C24.495 2.56178 23.9479 2.2 23.7085 1.64267L23.43 0.982666L23.4349 0.977778Z",
    fill: "#040000"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.8711 2.56711C18.8711 2.25422 19.1251 2 19.4378 2H22.7597L22.7793 2.044C23.175 2.97778 24.0885 3.584 25.1047 3.584H32.2909C33.3021 3.584 34.2205 2.97778 34.6162 2.04889L34.6358 2.00489H37.9577C38.2704 2.00489 38.5244 2.25911 38.5244 2.572V41.1747C38.5244 41.4876 38.2704 41.7418 37.9577 41.7418H19.4427C19.13 41.7418 18.876 41.4876 18.876 41.1747V2.56711H18.8711Z",
    fill: "#F16576"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 30,
    height: 51
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1892 10.002H0.380859V60.1424H29.1892V10.002Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7091 60.1369C14.4404 60.1369 14.2206 59.9169 14.2206 59.648C14.2206 59.5747 14.2352 59.5062 14.2646 59.4427L18.4219 50.4178C18.8029 49.5818 19.5406 48.9609 20.4297 48.736C22.8528 48.1298 25.0267 46.7658 26.6291 44.8445C26.9271 44.4778 27.2398 44.0965 27.5671 43.7249H19.4331C18.0213 43.7249 16.8733 42.576 16.8733 41.1631V38.0245C17.0296 36.1276 17.0296 34.2209 16.8733 32.324C16.7414 30.7254 16.4629 29.1414 16.0379 27.5916C15.7448 26.5502 15.7057 25.4551 15.9353 24.3942C16.2284 23.0156 16.6339 20.928 16.8782 18.8062C17.1664 16.2982 17.1664 14.3427 16.883 12.9982C16.6534 11.908 16.248 11.2676 15.6764 11.1014C15.2856 10.9351 14.841 10.9449 14.4551 11.1209C14.1033 11.4436 13.9275 11.9178 13.9763 12.392C13.9079 14.6409 13.1898 17.2125 11.8415 20.0285C9.81898 24.2671 8.73934 28.892 8.6856 33.5854L8.63187 39.6476C8.51462 40.8405 8.11892 41.9942 7.47895 43.0111L1.27957 52.7791C1.13301 53.0089 0.835014 53.0725 0.605407 52.9307C0.375801 52.784 0.312294 52.4858 0.453966 52.256L6.65334 42.488C7.20537 41.6129 7.54734 40.6254 7.65482 39.5938L7.70856 33.5805C7.76718 28.7405 8.87613 23.9738 10.9572 19.608C12.2469 16.9142 12.9309 14.4747 12.9993 12.3627C13.0286 11.3751 13.3412 10.6809 13.9226 10.2996C14.5626 9.95736 15.3198 9.90847 15.9939 10.1725C16.8977 10.4365 17.5328 11.3214 17.8406 12.7929C18.1434 14.24 18.1483 16.3031 17.8454 18.9138C17.5963 21.0747 17.1859 23.1965 16.8879 24.5947C16.6974 25.4942 16.7267 26.4329 16.9759 27.3178C17.4204 28.9262 17.7135 30.5689 17.8454 32.2311C18.0067 34.1671 18.0067 36.1178 17.8454 38.0538V41.1534C17.8454 42.0285 18.5538 42.7374 19.4283 42.7374H28.6907C28.9594 42.7374 29.1792 42.9574 29.1792 43.2262C29.1792 43.3582 29.1255 43.4805 29.0375 43.5734C28.4562 44.1698 27.9042 44.7956 27.3912 45.4507C25.6569 47.5334 23.3023 49.0098 20.674 49.6698C20.0682 49.8262 19.5699 50.2467 19.311 50.8138L15.1537 59.8387C15.0755 60.0098 14.8996 60.1222 14.7091 60.1222V60.1369Z",
    fill: "#040000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 16,
    width: 5,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5518 16.4902H39.541V22.2689H43.5518V16.4902Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5293 16.4893C41.8908 16.4893 42.2474 16.587 42.5601 16.7679C43.6055 17.3839 43.8645 18.7626 43.161 19.9702C42.3842 21.3097 40.308 22.1897 40.2201 22.2288C39.9709 22.3315 39.6827 22.2142 39.5801 21.9648C39.5557 21.9062 39.541 21.8426 39.541 21.7742V17.5795C39.541 17.4377 39.5996 17.3057 39.7071 17.2128C40.2201 16.7777 40.86 16.5235 41.5293 16.4844V16.4893ZM40.5181 20.9919C41.2313 20.6399 41.8468 20.1217 42.3158 19.4813C42.7408 18.7528 42.6285 17.9462 42.0618 17.6137C41.9006 17.5159 41.7198 17.467 41.5293 17.467C41.1629 17.4866 40.8112 17.6137 40.5181 17.8288V20.9968V20.9919Z",
    fill: "#040000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 23,
    width: 5,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0291 23.0371H39.541V28.5078H43.0291V23.0371Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8493 23.0371C41.2694 23.0469 41.6749 23.1691 42.0315 23.3891C43.077 24.0051 43.3359 25.3838 42.6324 26.5913C42.0462 27.4811 41.1815 28.1509 40.1702 28.4882C39.9113 28.5713 39.6377 28.4247 39.5596 28.1704C39.5449 28.1216 39.5352 28.0727 39.5352 28.0238V23.8291C39.5352 23.6971 39.584 23.5749 39.6768 23.482C39.9993 23.1936 40.4145 23.0322 40.8493 23.042V23.0371ZM40.5122 27.266C41.03 26.9971 41.4697 26.5962 41.7824 26.1024C42.2074 25.374 42.095 24.5673 41.5283 24.2349C41.3232 24.1029 41.0887 24.0296 40.8444 24.0198C40.7272 24.0198 40.6148 24.0442 40.5073 24.0882V27.2709L40.5122 27.266Z",
    fill: "#040000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 8,
    width: 6,
    height: 8
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4507 8.58008H39.541V15.3756H44.4507V8.58008Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5015 8.58008C42.6969 8.58008 42.8923 8.60452 43.0779 8.65341C43.7081 8.87341 44.1869 9.39652 44.353 10.0419C44.5728 10.8632 44.353 11.7432 43.757 12.3592C42.6822 13.4152 41.5293 14.3881 40.3129 15.273C40.0979 15.4343 39.7902 15.3903 39.629 15.1752C39.5654 15.0921 39.5312 14.9894 39.5312 14.8819V9.91474C39.5312 9.74363 39.6192 9.58719 39.7657 9.49919C39.8292 9.46008 41.2851 8.58008 42.4966 8.58008H42.5015ZM40.5181 13.8943C41.4072 13.2294 42.2474 12.4961 43.034 11.709C43.4052 11.3472 43.5518 10.8143 43.4199 10.3156C43.3417 9.99297 43.117 9.72897 42.8141 9.59697C42.7115 9.57252 42.609 9.55786 42.5064 9.55786C41.8078 9.6263 41.1287 9.8463 40.523 10.2032V13.8992L40.5181 13.8943Z",
    fill: "#040000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 28,
    width: 4,
    height: 6
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.565 28.8594H39.5605V33.0932H42.565V28.8594Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7428 28.8594C41.0066 28.8594 41.2704 28.9034 41.5146 29.0012C41.9641 29.182 42.3109 29.5438 42.4722 29.9985C42.6431 30.5265 42.5699 31.1034 42.2719 31.5727C41.8468 32.4332 41.0066 33.01 40.0491 33.0932C39.7804 33.0932 39.5605 32.8732 39.5605 32.6043V29.4558C39.5605 29.2456 39.6973 29.0598 39.8927 28.9914C40.1663 28.9083 40.4545 28.8643 40.7428 28.8594ZM40.5376 31.9687C40.9138 31.7732 41.2264 31.4652 41.4218 31.0887C41.5733 30.8638 41.6221 30.5852 41.5488 30.3212C41.4805 30.1354 41.3339 29.9838 41.1483 29.9056C41.0164 29.8567 40.8796 29.8323 40.7379 29.8372C40.6695 29.8372 40.6011 29.8372 40.5327 29.8469V31.9638L40.5376 31.9687Z",
    fill: "#040000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 14,
    width: 16,
    height: 16
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2282 14.457H21.1719V29.5246H36.2282V14.457Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7 29.5187C24.5427 29.5187 21.1719 26.1454 21.1719 21.985C21.1719 17.8245 24.5427 14.4512 28.7 14.4512C32.8574 14.4512 36.2282 17.8245 36.2282 21.985C36.2282 26.1405 32.8574 29.5138 28.7 29.5187ZM28.7 15.4338C25.085 15.4338 22.1489 18.3672 22.1489 21.9898C22.1489 25.6125 25.0801 28.5458 28.7 28.5458C32.32 28.5458 35.2512 25.6125 35.2512 21.9898C35.2512 18.3721 32.3151 15.4387 28.7 15.4338Z",
    fill: "#040000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 18,
    width: 5,
    height: 4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8058 18.4551H26.5898V21.2222H30.8058V18.4551Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6996 21.2225C28.5628 21.2225 28.4309 21.1639 28.3381 21.0612L26.7162 19.2767C26.5355 19.0763 26.5501 18.7683 26.7504 18.5874C26.9507 18.4065 27.2585 18.4212 27.4392 18.6216L28.6948 20.0101L29.9503 18.6216C30.131 18.4212 30.4388 18.4065 30.6391 18.5874C30.8394 18.7683 30.854 19.0763 30.6733 19.2767L29.0514 21.0612C28.9586 21.1639 28.8267 21.2225 28.6899 21.2225H28.6996Z",
    fill: "#040000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 20,
    width: 7,
    height: 2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4813 20.4551H25.9219V21.4329H31.4813V20.4551Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9928 21.4329H26.4104C26.1417 21.4329 25.9219 21.2129 25.9219 20.944C25.9219 20.6751 26.1417 20.4551 26.4104 20.4551H30.9928C31.2615 20.4551 31.4813 20.6751 31.4813 20.944C31.4813 21.2129 31.2615 21.4329 30.9928 21.4329Z",
    fill: "#040000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 22,
    width: 7,
    height: 2
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4813 22.6641H25.9219V23.6418H31.4813V22.6641Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9928 23.6418H26.4104C26.1417 23.6418 25.9219 23.4218 25.9219 23.153C25.9219 22.8841 26.1417 22.6641 26.4104 22.6641H30.9928C31.2615 22.6641 31.4813 22.8841 31.4813 23.153C31.4813 23.4218 31.2615 23.6418 30.9928 23.6418Z",
    fill: "#040000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_15731_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 20,
    width: 2,
    height: 6
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1899 20.4551H28.2129V25.9306H29.1899V20.4551Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_15731_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7014 25.9306C28.4327 25.9306 28.2129 25.7106 28.2129 25.4417V20.944C28.2129 20.6751 28.4327 20.4551 28.7014 20.4551C28.9701 20.4551 29.1899 20.6751 29.1899 20.944V25.4417C29.1899 25.7106 28.9701 25.9306 28.7014 25.9306Z",
    fill: "#040000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.d5ee33f8adc0b5f307547920fe5b86cb.svg";
export { ForwardRef as ReactComponent };